(() => {
  const onReady = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
  };

  onReady(() => {
    document.querySelectorAll('[data-campaign-countdown]').forEach((output) => {
      const parts = (output.dataset.countdownTime || '').split(':').map(Number);
      if (parts.length !== 3 || parts.some((part) => !Number.isInteger(part))) return;

      const [hours, minutes, seconds] = parts;
      if (hours > 23 || minutes > 59 || seconds > 59) return;

      let target = new Date();
      target.setHours(hours, minutes, seconds, 0);
      if (target <= new Date()) target.setDate(target.getDate() + 1);

      const updateCountdown = () => {
        const now = new Date();
        if (target <= now) {
          target = new Date(now);
          target.setDate(target.getDate() + 1);
          target.setHours(hours, minutes, seconds, 0);
        }

        const remaining = target - now;
        const remainingHours = Math.floor(remaining / 3600000);
        const remainingMinutes = Math.floor((remaining % 3600000) / 60000);
        const remainingSeconds = Math.floor((remaining % 60000) / 1000);
        output.textContent = `${remainingHours} u ${remainingMinutes} min ${remainingSeconds} s`;
      };

      updateCountdown();
      window.setInterval(updateCountdown, 1000);
    });

    document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
      const drawer = document.querySelector(button.getAttribute('aria-controls') ? `#${button.getAttribute('aria-controls')}` : '');
      if (!drawer) return;
      button.addEventListener('click', () => {
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!isOpen));
        drawer.toggleAttribute('data-open', !isOpen);
        document.body.classList.toggle('menu-open', !isOpen);
      });
      drawer.querySelectorAll('[data-menu-close]').forEach((close) => close.addEventListener('click', () => {
        button.setAttribute('aria-expanded', 'false');
        drawer.removeAttribute('data-open');
        document.body.classList.remove('menu-open');
      }));
    });

    document.querySelectorAll('[data-rail]').forEach((rail) => {
      const viewport = rail.querySelector('[data-rail-viewport]');
      if (!viewport) return;

      const usesAdaptiveControls = rail.closest('.category-rail') !== null;
      const controls = rail.querySelector('.rail__controls');
      const buttons = [...rail.querySelectorAll('[data-rail-direction]')];
      const previousButton = buttons.find((button) => button.dataset.railDirection === 'prev');
      const nextButton = buttons.find((button) => button.dataset.railDirection === 'next');

      const updateRailControls = () => {
        if (!usesAdaptiveControls) return;
        const maximumScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        const hasOverflow = maximumScroll > 1;
        rail.dataset.railOverflow = String(hasOverflow);
        if (controls) controls.hidden = !hasOverflow;
        if (previousButton) previousButton.disabled = !hasOverflow || viewport.scrollLeft <= 1;
        if (nextButton) nextButton.disabled = !hasOverflow || viewport.scrollLeft >= maximumScroll - 1;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          const direction = button.dataset.railDirection === 'next' ? 1 : -1;
          viewport.scrollBy({ left: direction * viewport.clientWidth * 0.82, behavior: 'smooth' });
        });
      });

      if (usesAdaptiveControls) {
        viewport.addEventListener('scroll', updateRailControls, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(updateRailControls).observe(viewport);
        window.requestAnimationFrame(updateRailControls);
      }
    });

    document.querySelectorAll('[data-seo-copy-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const root = button.closest('[data-seo-copy]');
        if (!root) return;
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        root.classList.toggle('is-expanded', expanded);
      });
    });

    document.querySelectorAll('[data-footer-menu-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const menu = button.closest('.footer-menu');
        if (!menu) return;
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        menu.classList.toggle('is-open', expanded);
      });
    });

    const revealObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.dataset.revealed = 'true';
            revealObserver.unobserve(entry.target);
          }
        }), { rootMargin: '0px 0px -8% 0px' })
      : null;
    document.querySelectorAll('[data-reveal]').forEach((element) => {
      if (revealObserver) revealObserver.observe(element);
      else element.dataset.revealed = 'true';
    });

    const siteHeader = document.querySelector('[data-site-header]');
    const headerSection = siteHeader?.closest('.scroll-header-section');
    if (headerSection) {
      let lastScrollY = Math.max(0, window.scrollY || 0);
      let scrollTicking = false;
      const measureHeader = () => {
        headerSection.style.setProperty('--header-height', `${siteHeader.offsetHeight}px`);
      };
      measureHeader();
      if ('ResizeObserver' in window) new ResizeObserver(measureHeader).observe(siteHeader);
      else window.addEventListener('resize', measureHeader);

      siteHeader.addEventListener('focusin', () => headerSection.removeAttribute('data-header-hidden'));

      const updateHeaderOnScroll = () => {
        const currentScrollY = Math.max(0, window.scrollY || 0);
        const direction = currentScrollY - lastScrollY;
        const interactionOpen = document.body.classList.contains('menu-open')
          || document.body.classList.contains('search-open')
          || document.body.classList.contains('cart-open');

        if (currentScrollY <= 8 || direction < 0 || interactionOpen) {
          headerSection.removeAttribute('data-header-hidden');
        } else if (direction > 0) {
          headerSection.setAttribute('data-header-hidden', 'true');
        }

        lastScrollY = currentScrollY;
        scrollTicking = false;
      };

      window.addEventListener('scroll', () => {
        if (scrollTicking) return;
        scrollTicking = true;
        window.requestAnimationFrame(updateHeaderOnScroll);
      }, { passive: true });

      updateHeaderOnScroll();
    }
  });
})();
